import LinkAnalytics from '../components/Analytics/LinkAnalytics';
import Breadcrumbs from '../components/Layout/Breadcrumbs';
import DashboardLayout from '../components/Layout/DashboardLayout';
import WhatsAppChat from '../components/support/WhatsAppChat';

export default function AnalyticsPage() {
      const breadcrumbItems = [
    { name: "Home", path: "/" },
    { name: "Dashboard", path: "/user-dashboard" },
    { name: "Manage Urls", path: "/dashboard/urls" },
    { name: "Analytics" }
  ];
  return (
    <DashboardLayout>
      <div className="analytics-page" style={{marginTop: "20px"}}>
        <Breadcrumbs items={breadcrumbItems} />
        <LinkAnalytics />
      </div>
      <WhatsAppChat position='right' />
    </DashboardLayout>
  );
}